export const isEmail = (data: any) => {
    return data && /(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/.test(data);
}
export const isPhoneNumber = (data: any) => {
    return data && /([0-9\s\-]{7,})(?:\s*(?:#|x\.?|ext\.?|extension)\s*(\d+))?$/.test(data);
}
export const isBusinessID = (data: any) => {
    return data && /(^[0-9]{6,7})-([0-9])/.test(data)
}
export const isPostalCode = (data: any) => {
    return data && data.length === 5;
}
export const required = (data: any) => {
    return data && data.length > 0;
}
export const isvalidPassword = (data: any) => {
    return data && /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,}$/.test(data)
}
export const notUndefined = (data: any) => {
    return !!data; 
}
export const isLengthValid = (data: any, maxLength: number) => {
    return !data || (data.length >= 0 && data.length <= maxLength);
}



// WEBPACK FOOTER //
// ./src/common/validators/formValidators.ts